import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})
export class MathHelper {

  static ensureAtLeastZero(value: number): number {
    return Math.max(value, 0);
  }

  static ceilTo4(value: number | string): number {
    const numberOfDecimals = 4;
    const n = Number(value);
    if (!Number.isFinite(n)) return n;

    // shift, ceil, shift back
    const factor = Math.pow(10, numberOfDecimals);
    const rounded = Math.ceil(n * factor) / factor;
    
    // for numbers like 27.400000000000002 the ceil above returns 27.4 so we add 0.0001 manually
    if (rounded < n) {
      return Number(rounded + 0.0001);
    }

    return rounded
  }

  static roundTo4(value: number | string): number {
    const numberOfDecimals = 4;
    const n = Number(value);
    if (!Number.isFinite(n)) return n;

    // shift, round, shift back
    const factor = Math.pow(10, numberOfDecimals);
    return Math.round(n * factor) / factor;
  }

}
